// extracted by mini-css-extract-plugin
module.exports = {"iconLocationWrapper":"ContentTitle_iconLocationWrapper__KxqAm","title":"ContentTitle_title__Y5bi_"};